module.exports = __webpack_public_path__ + "static/img/bystage_09.f6c2f591.svg";